// Server-side requests run inside the nuxt Docker container, where the Laravel
// API container isn't reachable at NUXT_API_BASE (usually a "localhost" URL that
// only resolves correctly from the host/browser). apiBaseServer lets local dev
// override that with a container-reachable address; it falls back to the public
// value everywhere else (including production, where apiBase is already a real
// public domain reachable from the server too).
export const useApiBase = () => {
  const config = useRuntimeConfig();
  const baseApi = import.meta.server && config.apiBaseServer
    ? config.apiBaseServer
    : config.public.baseApi;

  return { baseApi };
};
